import type { Progress } from '../ports/progress.ts';
import type { KeyValueStorage } from '../ports/storage.ts';
import { progressKey } from '../web/local-progress-repo.ts';

/**
 * Writes a whole record in the format `createLocalProgressRepo` reads (same key scheme), so the
 * sync can apply a merge without replaying answers. Never throws: when the storage refuses, the
 * merged data simply is not kept locally (it is still on the server).
 */
export function createStorageWriter(
  storage: KeyValueStorage,
  namespace = 'dcs',
): (progress: Progress) => void {
  return (progress) => {
    try {
      storage.set(progressKey(progress.licenseClass, namespace), JSON.stringify(progress));
    } catch {
      // Not persisted locally.
    }
  };
}
